module.exports = "/assets/logo-852df94778d1c2b59c1ffc703050a2f2.svg";